import { Breadcrumb, BreadcrumbProps } from 'antd'
import BreadcrumbItem from 'antd/lib/breadcrumb/BreadcrumbItem'
import dynamic from 'next/dynamic'
import Link from 'next/link'
import React from 'react'

export const PageContainer = dynamic(
  async () => (await import('@ant-design/pro-layout')).PageContainer,
  { ssr: false }
)

PageContainer.defaultProps = {
  breadcrumbRender: ({ breadcrumb }) => (
    <Breadcrumb>
      {(breadcrumb as BreadcrumbProps).items?.map((route, index, items) => (
        <BreadcrumbItem key={route.path}>
          {index === items.length - 1 ? (
            route.breadcrumbName
          ) : (
            <Link href={route.path ?? ''}>{route.breadcrumbName}</Link>
          )}
        </BreadcrumbItem>
      ))}
    </Breadcrumb>
  ),
}
